import { render } from "./DemoMode.vue?vue&type=template&id=0d5c3ba9"
import script from "./DemoMode.vue?vue&type=script&lang=js"
export * from "./DemoMode.vue?vue&type=script&lang=js"

import "./DemoMode.vue?vue&type=style&index=0&id=0d5c3ba9&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__